/* eslint-disable react/button-has-type */
import React, { useState } from 'react';
import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
import { getFilePlugin } from '@react-pdf-viewer/get-file';
import { getAllPagesNumbers, printPlugin } from '@react-pdf-viewer/print';
import { zoomPlugin } from '@react-pdf-viewer/zoom';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/print/lib/styles/index.css';
import '@react-pdf-viewer/zoom/lib/styles/index.css';

import { Button } from '../Button';
import type { PdfPresenterExtendProps } from './PdfPresenter';

type PdfViewerProps = {
	//
} & PdfPresenterExtendProps;

export const PdfViewer = ({ title, src }: PdfViewerProps) => {
	const getFilePluginInstance = getFilePlugin();
	const printPluginInstance = printPlugin({
		enableShortcuts: true,
		setPages: getAllPagesNumbers,
	});
	const zoomPluginInstance = zoomPlugin();

	const Download = getFilePluginInstance.Download as any;
	const Print = printPluginInstance.Print as any;
	const ZoomIn = zoomPluginInstance.ZoomIn as any;
	const ZoomOut = zoomPluginInstance.ZoomOut as any;
	const ZoomPopover = zoomPluginInstance.ZoomPopover as any;

	const workerUrl = `${process.env.REACT_APP_FRONT_URL}/static/js/pdf.worker.min.js?v=1`;

	const [ready, setReady] = useState(false);

	return (
		<>
			<div className="flex items-center gap-2 justify-content-between align-items-center">
				<div className="flex gap-2 align-items-center">
					<ZoomOut>
						{(props: any) => (
							<Button
								label="Oddal"
								onClick={props.onClick}
								icon="minus"
								iconOnly
								variantSize="sm"
								disabled={!ready}
							/>
						)}
					</ZoomOut>
					<ZoomPopover />
					<ZoomIn>
						{(props: any) => (
							<Button
								label="Przybliż"
								onClick={props.onClick}
								icon="plus"
								iconOnly
								variantSize="sm"
								disabled={!ready}
							/>
						)}
					</ZoomIn>
				</div>
				<div className="flex gap-2 align-items-center">
					<Print>
						{(props: any) => (
							<Button
								label="Drukuj"
								onClick={props.onClick}
								icon="print"
								variantSize="sm"
								disabled={!ready}
							/>
						)}
					</Print>
					<Download>
						{(props: any) => (
							<Button
								label="Pobierz"
								onClick={props.onClick}
								icon="download"
								variantSize="sm"
								disabled={!ready}
							/>
						)}
					</Download>
				</div>
			</div>

			<div className="flex-1 h-full overflow-hidden">
				<Worker workerUrl={workerUrl}>
					{src && (
						<Viewer
							fileUrl={src}
							defaultScale={SpecialZoomLevel.PageWidth}
							plugins={[getFilePluginInstance, printPluginInstance, zoomPluginInstance]}
							onDocumentLoad={(e) => {
								setReady(true);
							}}
						/>
					)}
				</Worker>
			</div>
		</>
	);
};
